import { errorValidation } from './utils';

/**
 * Validate forms
 */
(() => {
	// Login
	$("form[name='login']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'login[email]': {
				required: true,
				email: true,
			},
			'login[password]': {
				required: true,
			},
		},
		messages: {
			'login[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'login[password]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
